import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { checkPermissionApi } from 'utils/API/Merchant APIs/UpdatedAPIs/AEPSUpdatedApiCall';

const AepsFinoAuth = (WrappedComponent) => {
    const AuthWrapper = (props) => {
        const navigate = useNavigate();

        useEffect(() => {
            const checkPermission = async () => {
                try {
                    const responsePermission = await checkPermissionApi();
                    console.log('response', responsePermission);

                    const response = responsePermission?.data?.data;
                    console.log('data', response);

                    if (response?.isFinoOnboarded === false) {
                        navigate('/aeps/aeps2onboarding');
                    }
                } catch (error) {
                    console.log('error', error);
                }
            };

            checkPermission();
        }, [navigate]);

        return <WrappedComponent {...props} />;
    };

    return AuthWrapper;
};

export default AepsFinoAuth;
